import React, { FC, useState } from "react";

import { useTranslation } from "react-i18next";

import { useSort } from "@/components/atoms";
import SearchList from "@/components/templates/SearchList/SearchList";
import { InvoiceSortProperty, SortOrder } from "@/shared/domain";

import InvoiceCard from "../components/InvoiceCard/InvoiceCard";
import InvoiceTable from "../components/InvoiceTable/InvoiceTable";
import useInvoicesQueries from "../useInvoicesQueries";

const InvoiceSearchPage: FC = () => {
    const { t } = useTranslation();
    const [orderBy, orderByActions] = useSort<InvoiceSortProperty>({
        sort: { property: "date", order: SortOrder.Ascending },
    });
    const [textSearch, setTextSearch] = useState("");

    const { tableMode, useInvoicesSearchQuery } = useInvoicesQueries();
    const { result, isFetching } = useInvoicesSearchQuery({
        textSearch,
        sortProperty: orderByActions.getManualSortProperty(),
    });

    const renderItem = (invoice: MyBrokerApi.Invoice) => <InvoiceCard key={invoice.id} invoice={invoice} />;
    const renderTable = (items: MyBrokerApi.Invoice[]) => (
        <InvoiceTable invoices={items} orderBy={orderBy} handleSort={orderByActions.updateSort} />
    );

    return (
        <SearchList<MyBrokerApi.Invoice>
            items={result}
            tableMode={tableMode}
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            renderItem={renderItem}
            renderTable={renderTable}
            isFetching={isFetching}
            placeholder={t("Common.Search")}
            emptyListMessage={t("Invoices.Empty")}
            pageTitle={t("Common.Search")}
        />
    );
};

export default InvoiceSearchPage;
